module.exports = __webpack_public_path__ + "img/T1B_rc_17.23fe06e4.png";